import React from "react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { useNavigate } from "react-router-dom";
import OrganisationLayout from "../../components/organisation/layout/OrganisationLayout";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import {
  fetchAllCustomers,
  fetchFilteredCustomersAction,
} from "../../store/slices/customer/action";
import GreendotDot from "../../assets/icons/GreenDotIcon.svg";
import { getFromSessionStorage } from "../../utils/browserStorage";
import { toast } from "react-toastify";
import { BiSearchAlt } from "react-icons/bi";
import {
  CustomerAccount,
  CustomerProfile,
} from "../../store/slices/customer/types";
import { getMainProfile } from "../../utils/helper";
import { fetchFilteredOrganisationOrdersAction } from "../../store/slices/order/action";
import { BaseStatusLabel } from "../../components/base";
const OrdersList = () => {
  const { organisationOrdersData } = useAppSelector(
    (state) => state.orderReducer
  );
  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );
  const headerStyle = {
    color: "#0C4654",
    fontSize: "0.875rem",
    fontWeight: "500",
    backgroundColor: "transparent",
  };
  const bodyStyle = {
    color: "#0C4654",
    fontSize: "1rem",
    fontWeight: "500",
    backgroundColor: "transparent",
  };

  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState(null);

  const [lazyParams, setLazyParams] = useState({
    organisationId: currentOrganisationAccount?.organisationId,
    first: 1,
    rows: 10,
    page: 1,
    filters: {
      global: { value: "", matchMode: FilterMatchMode.CONTAINS },
    },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLazyData(lazyParams);
  }, []);

  const loadLazyData = async (lazyParams: any) => {
    setLoading(true);
    const { payload } = await dispatch(
      fetchFilteredOrganisationOrdersAction(lazyParams)
    );

    if (payload?.status === 200) {
      setLoading(false);
    } else {
      toast.error(
        "Something went wrong while fetching customers. Pls try again"
      );
      setLoading(false);
    }
  };

  const onPage = (event: any) => {
    setLazyParams({
      filters: lazyParams.filters,
      organisationId: lazyParams.organisationId,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    });

    loadLazyData({
      filters: lazyParams.filters,
      organisationId: lazyParams.organisationId,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    });
  };

  const onSelectionChange = (event: any) => {
    const value = event.value;
    navigate(`/dashboard/orders/${event?.value?._id}`, {
      state: {
        ...lazyParams,
      },
    });
  };

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    if (e.target.value.length >= 3) {
      let _filters = { ...lazyParams.filters };
      _filters["global"].value = value;
      setGlobalFilterValue(value);
      setLazyParams({ ...lazyParams, filters: _filters });
      loadLazyData({
        ...lazyParams,
        filters: _filters,
      });
    }
    if (e.target.value === "") {
      loadLazyData({
        ...lazyParams,
        filters: {
          global: { value: "", matchMode: FilterMatchMode.CONTAINS },
        },
      });
    }
  };

  const fullNameBodyTemplate = (rowData: any) => {
    return (
      <div className="flex justify-center items-center">
        <p className="text-left">
          {rowData?.user?.title || ""} {rowData?.user?.firstName}{" "}
          {rowData?.user?.lastName}{" "}
        </p>
      </div>
    );
  };

  const createdAtBodyTemplate = (rowData: any) =>
    rowData?.createdAt ? (
      <div>
        <span>
          {
            new Date(rowData?.createdAt)
              .toLocaleString("en-GB", { timeZone: "UTC" })
              .split(",")[0]
          }
        </span>
      </div>
    ) : (
      "----------"
    );

  //   const orderCountBodyTemplate = (rowData: any) =>
  //     rowData?.orders ? <p>{rowData?.orders?.length}</p> : "----------";

  const genderBodyTemplate = (rowData: CustomerProfile) => {
    return <>{rowData?.gender || "---------"}</>;
  };

  const statusBodyTemplate = (rowData: any) => {
    return <BaseStatusLabel status={rowData?.orderStatus} />;
  };

  const appointmentDateBodyTemplate = (rowData: any) =>
    rowData?.appointments &&
    rowData?.appointments[0]?.proposedAppointmentDate ? (
      <div>
        <span>
          {
            new Date(rowData?.appointments[0]?.proposedAppointmentDate)
              .toLocaleString("en-GB", { timeZone: "UTC" })
              .split(",")[0]
          }
        </span>
      </div>
    ) : (
      "----------"
    );

  return (
    <>
      <OrganisationLayout>
        <div className="px-3 lg:px-12 mt-5">
          <div className="mb-6">
            <h1 className="text-[#0C4654] font-[500] text-[1.2rem]">Orders</h1>
          </div>

          <div className="bg-[#F2F6FA] rounded px-3 py-6 text-[#0C4654]">
            <div className="mb-4 px-3">
              <label className="relative">
                <BiSearchAlt
                  className="textbrandColor absolute left-3 top-1"
                  size="1rem"
                />
                <input
                  type="text"
                  className="border p-4 pl-8 rounded-[0.5rem] w-full text-[0.875rem] font-[500] placeholder-[#767B86] focus:outline-none"
                  placeholder="Search"
                  onKeyUp={onGlobalFilterChange}
                />
              </label>
            </div>
            <div className="p-3 mt-2 rounded-[8px]">
              <DataTable
                value={organisationOrdersData?.orders}
                lazy
                paginator
                className="h-full"
                // header={header}
                first={lazyParams?.first}
                rows={lazyParams?.rows}
                totalRecords={organisationOrdersData?.total}
                onPage={onPage}
                // onSort={onSort}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                dataKey="id"
                rowHover
                sortField={sortField}
                sortOrder={sortOrder}
                scrollable
                onSelectionChange={onSelectionChange}
                loading={loading}
                selectionMode="single"
                responsiveLayout="scroll"
                globalFilterFields={["name", "unit"]}
                emptyMessage="No orders found."
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} orders"
              >
                <Column
                  field="uniqueId"
                  header="Order ID"
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="name"
                  header="Customer's Name"
                  body={fullNameBodyTemplate}
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="status"
                  header="Status"
                  body={statusBodyTemplate}
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                />
                {/* <Column
                  field="mobile"
                  header="Phone Number"
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                /> */}
                <Column
                  field="createdDate"
                  header="Order Date"
                  body={createdAtBodyTemplate}
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                  }}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="createdDate"
                  header="Appointment Date"
                  body={appointmentDateBodyTemplate}
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                  }}
                  bodyStyle={bodyStyle}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </OrganisationLayout>
    </>
  );
};

export default OrdersList;

// export default WithOrganisationAuth(OrganisationDashboard);
